import { ActionConfig, MatchStatus } from "./types";

export const ACTION_FLOWS: Record<string, ActionConfig> = {
  Pass: {
    actions: ["Pass"],
    outcomes: { Pass: ["Complete", "Incomplete", "Stolen", "OutOfBounds"] },
    needsRecipient: true,
  },
  Shot: {
    actions: ["Shot"],
    outcomes: {
      Shot: ["Made", "Missed", "Blocked", "AndOne"],
    },
  },
  "2PT": {
    actions: ["2PT"],
    outcomes: {
      "2PT": ["Made", "Missed", "Blocked", "AndOne"],
    },
  },
  "3PT": {
    actions: ["3PT"],
    outcomes: {
      "3PT": ["Made", "Missed", "Blocked", "AndOne"],
    },
  },
  FreeThrow: {
    actions: ["FreeThrow"],
    outcomes: {
      FreeThrow: ["Made", "Missed"],
    },
  },
  Duel: {
    actions: ["Duel"],
    outcomes: { Duel: ["Won", "Lost"] },
  },
  FoulCommitted: {
    actions: ["Foul"],
    outcomes: {
      Foul: [
        "Personal",
        "Shooting",
        "Offensive",
        "Flagrant1",
        "Flagrant2",
        "Technical",
        "LooseBall",
      ],
    },
  },
  Interception: {
    actions: ["Interception"],
    outcomes: { Interception: ["Success", "Lost"] },
  },
  Block: {
    actions: ["Block"],
    outcomes: { Block: ["Success"] },
  },
  Recovery: {
    actions: ["Recovery"],
    outcomes: { Recovery: ["LooseBall", "Deflection", "Rebound"] },
  },
  Steal: {
    actions: ["Steal"],
    outcomes: { Steal: ["Success"] },
  },
  Rebound: {
    actions: ["Rebound"],
    outcomes: { Rebound: ["Offensive", "Defensive"] },
  },
  Turnover: {
    actions: ["Turnover"],
    outcomes: {
      Turnover: [
        "BadPass",
        "LostBall",
        "Traveling",
        "DoubleDribble",
        "ShotClockViolation",
        "OutOfBounds",
        "OffensiveFoul",
        "Backcourt",
        "Other",
      ],
    },
  },
  Violation: {
    actions: ["Violation"],
    outcomes: {
      Violation: [
        "Traveling",
        "DoubleDribble",
        "Goaltending",
        "ShotClock",
        "ThreeSeconds",
        "FiveSeconds",
        "EightSeconds",
        "Backcourt",
        "LaneViolation",
        "KickBall",
      ],
    },
  },
  Assist: {
    actions: ["Assist"],
    outcomes: { Assist: ["Success"] },
    needsRecipient: true,
  },
  JumpBall: {
    actions: ["JumpBall"],
    outcomes: { JumpBall: ["Won", "Lost"] },
  },
  Substitution: {
    actions: ["Substitution"],
    outcomes: {
      Substitution: [], // No outcomes - handled by modal
    },
    isSpecial: true, // Special handling - opens substitution flow modal
  },
  GameStoppage: {
    actions: ["Timeout", "Injury", "Review", "Other"],
    outcomes: {
      Timeout: ["Full", "Twenty"],
      Injury: ["Stoppage"],
      Review: ["Confirmed", "Overturned", "Inconclusive"],
      Other: ["Stoppage"],
    },
  },
  Ejected: {
    actions: ["Ejected"],
    outcomes: { Ejected: ["Ejected"] },
  },
  Disqualified: {
    actions: ["Disqualified"],
    outcomes: { Disqualified: ["Disqualified"] },
  },
};

export const QUICK_ACTIONS = [
  "2PT",
  "3PT",
  "FreeThrow",
  "Rebound",
  "Assist",
  "Steal",
  "Turnover",
  "Foul",
  "Pass",
  "Block",
  "Ejected",
  "Disqualified",
] as const;

export const DEFAULT_PERIOD_MAP: Record<MatchStatus, number> = {
  Scheduled: 1,
  Live: 1,
  Halftime: 2,
  Completed: 4,
  Live_Q1: 1,
  Break_Q1: 1,
  Live_Q2: 2,
  Live_Q3: 3,
  Break_Q3: 3,
  Live_Q4: 4,
  Fulltime: 4,
  Live_OT: 5,
  Break_OT: 5,
  Abandoned: 1,
  Pending: 1,
};

export const KEY_ACTION_MAP: Record<string, string> = {
  // Core actions
  p: "Pass",
  P: "Pass",
  s: "Shot",
  S: "Shot",
  d: "Duel",
  D: "Duel",
  f: "Foul",
  F: "Foul",
  i: "Interception",
  I: "Interception",
  b: "Block",
  B: "Block",
  r: "Recovery",
  R: "Recovery",
  // Basketball-specific
  a: "Assist",
  A: "Assist",
  e: "Rebound",
  E: "Rebound",
  t: "Turnover",
  T: "Turnover",
  l: "Steal",
  L: "Steal",
  v: "Violation",
  V: "Violation",
  j: "JumpBall",
  J: "JumpBall",
  // Stoppages
  o: "Timeout",
  O: "Timeout",
  // Special
  x: "Substitution",
  X: "Substitution",
  // Clock control
  " ": "ToggleClock",
};
